export default __webpack_public_path__ + "static/media/review-intake.d40e75be.png";